import { Box, Button, Card, Typography } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import { useDataProvider } from 'ra-core';
import { useNotify, useRefresh } from 'react-admin';
import JoditEditor from 'jodit-react';

const LegalStaffTab = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const editor = useRef(null);

  const [id, setId] = useState('');
  const [policy, setPolicy] = useState('');
  const [conditions, setConditions] = useState('');

  const handleChangePolicy = (eOrHtml) => {
    // setPolicy(newContent);
    const newContent =
      typeof eOrHtml === 'string'
        ? eOrHtml
        : eOrHtml && eOrHtml.currentTarget && eOrHtml.currentTarget.innerHTML;

    if (newContent) {
      setPolicy(newContent);
    }
  };

  const handleChangeConditions = (eOrHtml) => {
    // setConditions(newContent);
    const newContent =
      typeof eOrHtml === 'string'
        ? eOrHtml
        : eOrHtml && eOrHtml.currentTarget && eOrHtml.currentTarget.innerHTML;

    if (newContent) {
      setConditions(newContent);
    }
  };

  useEffect(() => {
    getGeneral();
  }, []);

  const getGeneral = async () => {
    const result = await dataProvider.getGeneral();
    const policy = result.data.policy ? result.data.policy : '';
    const conditions = result.data.conditions ? result.data.conditions : '';
    setId(result.data._id);
    setPolicy(policy);
    setConditions(conditions);
  };
  const handleSave = async () => {
    const result = await dataProvider.updateGeneral({
      id: id,
      data: { conditions: conditions },
      previousData: {} as any,
    });
    if (!result.data) {
      notify('something went wrong', 'error');
    }
    notify(`Successfully update`);
    refresh();
  };

  const handleSavePrivacy = async () => {
    const result = await dataProvider.updateGeneral({
      id: id,
      data: { policy: policy },
      previousData: {} as any,
    });
    if (!result.data) {
      notify('something went wrong', 'error');
    }
    notify(`Successfully update`);
    refresh();
  };

  return (
    <Card component='div' className='privacy-wrapper'>
      <Box>
        <Box marginBottom={0.5}>
          <Typography variant='h5'>Privacy policy</Typography>
        </Box>
        <div className='privacy-text-area-form'>
          <div className='privacy-text-area'>
            <JoditEditor
              ref={editor}
              value={policy}
              onBlur={(newContent) => handleChangePolicy(newContent)} // preferred to use only this option to update the content for performance reasons
              onChange={() => {}}
            />
          </div>
        </div>
      </Box>
      <Box padding='1rem'>
        <Button
          variant='contained'
          color='primary'
          disableElevation
          onClick={handleSavePrivacy}
        >
          Save
        </Button>
      </Box>
      <Box>
        <Box marginBottom={0.5}>
          <Typography variant='h5'>Terms of use</Typography>
        </Box>
        <div className='privacy-text-area-form'>
          <div className='privacy-text-area'>
            <JoditEditor
              ref={editor}
              value={conditions}
              onBlur={(newContent) => handleChangeConditions(newContent)} // preferred to use only this option to update the content for performance reasons
              onChange={() => {}}
            />
          </div>
        </div>
      </Box>
      <Box padding='1rem'>
        <Button
          variant='contained'
          color='primary'
          disableElevation
          onClick={handleSave}
        >
          Save
        </Button>
      </Box>
    </Card>
  );
};
export default LegalStaffTab;
